export default __webpack_public_path__ + "static/media/logoSEI.3d61ade3.png";